import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-field-auto-complete__container" }
const _hoisted_2 = { class: "gfu-field-auto-complete__search-box" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-field-auto-complete__selected-prefix"
}
const _hoisted_4 = ["name"]
const _hoisted_5 = ["placeholder", "maxlength", "name"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "gfu-field-select__content-wrapper gfu-field-auto-complete__suggestions" }
const _hoisted_8 = {
  ref: "itemList",
  "data-qa": "auto-complete-field:Suggestions"
}
const _hoisted_9 = {
  class: "gfu-field-select__group-header gfu-field-auto-complete__suggestions-header",
  "data-qa": "auto-complete-field:NoMatches"
}
const _hoisted_10 = ["tabindex", "onClick", "onKeyup", "onKeydown", "data-qa"]
const _hoisted_11 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    name: _ctx.name,
    class: "gfu-field-item",
    "data-qa": `auto-complete-field:${_ctx.name}`
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_toggle_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_toggle_trigger, {
              ref: "toggleTrigger",
              tag: "div",
              tabindex: "0",
              "active-class": "gfu-field-select__trigger--active",
              "handle-click": false,
              "focus-children": true,
              onCollapse: $options.onCollapse
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  ($options.hasSelectedItemPrefix)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "selected-item-prefix", {
                          item: _ctx.selectedItem,
                          label: $props.itemNameFinder(_ctx.selectedItem)
                        })
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.readOnly)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchTerm) = $event)),
                        class: _normalizeClass(['gfu-field__input gfu-field__input--readonly', {
                                   'gfu-field__input--small': $props.small,
                                   'gfu-field-auto-complete__input--with-prefix': $options.hasSelectedItemPrefix,
                               }]),
                        type: "text",
                        readonly: "readonly",
                        autocomplete: "off",
                        name: _ctx.name,
                        "data-qa": "auto-complete-field-readonly"
                      }, null, 10 /* CLASS, PROPS */, _hoisted_4)), [
                        [_vModelText, _ctx.searchTerm]
                      ])
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _withDirectives(_createElementVNode("input", {
                          ref: "searchField",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.searchTerm) = $event)),
                          placeholder: _ctx.placeholder,
                          maxlength: $props.maxInputLength,
                          name: _ctx.name,
                          autocomplete: "off",
                          class: _normalizeClass(['gfu-field__input', {
                                       'gfu-field__input--small': $props.small,
                                       'gfu-field-auto-complete__input--with-prefix': $options.hasSelectedItemPrefix,
                                   }]),
                          "aria-autocomplete": "both",
                          "aria-haspopup": "false",
                          onFocus: _cache[2] || (_cache[2] = (...args) => ($options.onInputFocus && $options.onInputFocus(...args))),
                          onBlur: _cache[3] || (_cache[3] = (...args) => ($options.onInputBlur && $options.onInputBlur(...args))),
                          onKeyup: [
                            _cache[4] || (_cache[4] = _withKeys(_withModifiers($event => ($options.selectNextItem(-1)), ["stop","prevent"]), ["down"])),
                            _cache[5] || (_cache[5] = _withKeys(_withModifiers($event => ($options.selectNextItem(-1)), ["stop","prevent"]), ["up"])),
                            _cache[6] || (_cache[6] = _withKeys((...args) => ($options.onCollapse && $options.onCollapse(...args)), ["esc"])),
                            _cache[7] || (_cache[7] = _withKeys((...args) => ($options.onEnter && $options.onEnter(...args)), ["enter"])),
                            _cache[8] || (_cache[8] = (...args) => ($options.onInput && $options.onInput(...args)))
                          ],
                          "data-qa": "auto-complete-field:Search"
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5), [
                          [_vModelText, _ctx.searchTerm]
                        ]),
                        (_ctx.searchTerm)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              "aria-label": _ctx.Resources.Common.AutocompleteClearButtonLabel,
                              class: _normalizeClass(['gfu-field-auto-complete__clear gfu-btn', {'gfu-field-auto-complete__clear--small': $props.small}]),
                              onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => ($options.clear && $options.clear(...args)), ["stop","prevent"])),
                              "data-qa": "auto-complete-field-btn:Clear"
                            }, [
                              _createVNode(_component_base_icon, { name: "times" })
                            ], 10 /* CLASS, PROPS */, _hoisted_6))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                ])
              ]),
              _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["onCollapse"]),
            _createVNode(_component_toggle_content, {
              tag: "div",
              class: "gfu-field-select__content",
              "active-class": "gfu-field-select__content--expanded",
              "data-qa": "select-content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", _hoisted_8, [
                    ($props.allowCreate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($props.allowDuplicate || $options.isNewItem)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                tabindex: 0,
                                class: "_pt-1 _pb-1",
                                onKeydown: [
                                  _cache[10] || (_cache[10] = _withKeys(_withModifiers($event => ($options.selectNextItem(0)), ["prevent"]), ["down"])),
                                  _cache[11] || (_cache[11] = _withKeys(_withModifiers($event => ($options.selectPreviousItem(0)), ["prevent"]), ["up"]))
                                ],
                                onClick: _cache[12] || (_cache[12] = _withModifiers((...args) => ($options.createItem && $options.createItem(...args)), ["prevent"]))
                              }, [
                                _createVNode(_component_base_badge, {
                                  class: "_my-1",
                                  theme: "suggestion",
                                  "data-qa": "auto-complete-field-btn:CreateNew"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.createNewLabel), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.searchTerm), 1 /* TEXT */)
                              ], 32 /* NEED_HYDRATION */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.filteredItems.length ? $props.matchingItemsLabel : $props.noMatchesLabel), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'matching-item-'+index,
                        tabindex: $options.getItemIndex(index),
                        onClick: _withModifiers($event => ($options.selectItem(item)), ["prevent"]),
                        onKeyup: _withKeys($event => ($options.selectItem(item)), ["enter"]),
                        onKeydown: [
                          _withKeys(_withModifiers($event => ($options.selectNextItem($options.getItemIndex(index))), ["prevent"]), ["down"]),
                          _withKeys(_withModifiers($event => ($options.selectPreviousItem($options.getItemIndex(index))), ["prevent"]), ["up"])
                        ],
                        "data-qa": 'auto-complete-field-item:'+ item.name
                      }, [
                        _renderSlot(_ctx.$slots, "item", {
                          item: item,
                          label: $props.itemNameFinder(item),
                          isSelected: $options.valuesAreEqual($props.itemValueFinder(item), _ctx.modelValue)
                        }, () => [
                          _createTextVNode(_toDisplayString($props.itemNameFinder(item)), 1 /* TEXT */)
                        ])
                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!$props.allowCreate && !_ctx.filteredItems.length)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString($options.isBusy ? 'Loading...' : $props.noMatchesLabel), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 512 /* NEED_PATCH */),
                  _createVNode(_component_progress_overlay, { visible: $options.isBusy }, null, 8 /* PROPS */, ["visible"])
                ])
              ]),
              _: 3 /* FORWARDED */
            })
          ]),
          _: 3 /* FORWARDED */
        })
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["name", "data-qa"]))
}